export default __webpack_public_path__ + "static/media/id.ad36dfb4.jpg";